// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import UIAvatar from 'ui-addon-avatars/UIAvatar';
import { getBusinessUnitDisplayName } from '../utils/String';
import { jsx as _jsx } from "react/jsx-runtime";
export const makeBusinessUnitSelectOption = ({
  id,
  name,
  logoUrl,
  logoAltText,
  resizedUrl
}, showOptionImage) => {
  const displayName = getBusinessUnitDisplayName(name, id);
  let imageOrAvatar = {};
  if (showOptionImage) {
    imageOrAvatar = resizedUrl || logoUrl ? {
      imageUrl: resizedUrl || logoUrl,
      logoAltText
    } : {
      avatar: /*#__PURE__*/_jsx(UIAvatar, {
        displayName: displayName,
        type: "contact",
        size: "xl"
      })
    };
  }
  return Object.assign({
    text: displayName,
    value: id
  }, imageOrAvatar);
};